module.exports = __webpack_public_path__ + "static/media/join-in-banner2.2c665272.png";